/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Discount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Discount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Discount/Content/Expandable/Content/Discount"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let discountNameValueData = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let discountAmountValueData = fromData.useDataFormat({ viewPath,
context: 'discount',
path: 'amount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="Discount.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-1-oolC6': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral600}
 data="discount.name"
 text={discountNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 weight="semibold"
 data="discount.amount"
 format="/Data/format.js numberMoney"
 text={discountAmountValueData}
/>
</div>
{children}
</React.Fragment>)
}